import { ITimeZone } from '../types/ITimeZone';
import { Request } from './Request';

export interface IGetUserSelectableSiteTimeZonesParams {
}

export interface IGetUserSelectableSiteTimeZonesResult {
    extraTimeZonesList: ITimeZone[];
    curatedTimeZonesList: ITimeZone[];
    serverTimeZone: ITimeZone;
}

export class GetUserSelectableSiteTimeZonesRequest extends Request<IGetUserSelectableSiteTimeZonesParams, IGetUserSelectableSiteTimeZonesResult> {
    constructor(params: IGetUserSelectableSiteTimeZonesParams = {}) {
        super('getUserSelectableSiteTimeZones', params);
    }
}
